import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'buk-oembed-card',
  template: `<div #insertionPoint style="display: none"></div>`
})
export class BukOembedCardComponent implements OnInit {
  @ViewChild('insertionPoint', { static: true }) insertionPoint: ElementRef<HTMLElement>;

  @Output() cardError = new EventEmitter<void>();

  private cardFetchSubscription: Subscription;

  private _cardId: string;

  private readonly defaultHeaders = new HttpHeaders({
    'Accept': 'application/json'
  });

  constructor(
    private element: ElementRef,
    private http: HttpClient,
    private router: Router
  ) { }

  ngOnInit() {
  }

  @Input()
  set cardId(cardId) {
    if (cardId && this.cardId !== cardId) {
      if (this.cardFetchSubscription) {
        this.cardFetchSubscription.unsubscribe();
      }

      this.cardFetchSubscription =
        this.fetchCard(cardId).subscribe((html) => {
          this.cardFetchSubscription = null;
          this.printHtml(html);
        }, (error) => {
          this.cardError.emit();
        });
    }

    this._cardId = cardId;
  }

  get cardId(): string {
    return this._cardId;
  }

  get isFetching(): boolean {
    return !!this.cardFetchSubscription;
  }

  fetchCard(cardId: string): Observable<string> {
    return this.http.get<any>(`https://buk.io/${cardId}`, {
      headers: this.defaultHeaders
    }).pipe(map((response) => {
      return response.inline || response.html;
    }));
  }

  printHtml(html: string) {
    this.clearPreviousHtml();

    const temp = document.createElement('div');
    this.element.nativeElement.insertBefore(temp, this.insertionPoint.nativeElement);
    temp.outerHTML = html;

    // FIXME
    this.element.nativeElement.querySelectorAll('a').forEach((a: HTMLAnchorElement) => {
      const href = a.getAttribute('href');
      if (href && href[0] === '#') {
        a.setAttribute('href', '');
        a.setAttribute('data-href', href);
        a.addEventListener('click', (event) => {
          event.preventDefault();
          this.router.navigate([], { fragment: href.substring(1) });
        });
      }
    });
  }

  clearPreviousHtml() {
    while (this.insertionPoint.nativeElement.previousElementSibling) {
      this.element.nativeElement.removeChild(
        this.insertionPoint.nativeElement.previousElementSibling
      );
    }
  }

}
